import type {PrimerComponentSubnav} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentSubnav'
import {Link} from '@primer/react-brand'

import Styles from './NavBack.module.css'

type Props = {
  content: PrimerComponentSubnav
}

export function NavBack(props: Props) {
  const {content} = props

  const {heading} = content.fields

  // Back link can be disabled in Contentful by setting the text to "disabled"

  return heading && heading.fields.text !== 'disabled' ? (
    <section className={Styles.NavBack}>
      <div className={Styles.Container}>
        <Link className={Styles.Link} href={heading.fields.href} arrowDirection="start">
          {heading.fields.text}
        </Link>
      </div>
    </section>
  ) : null
}
